import { CountryCard } from '../components/CountryCard'
import { CreditsCard } from '../components/CreditsCard'
import { LanguageCard } from '../components/LanguageCard'
import { ProfileHeader } from '../components/ProfileHeader'
import { RecentUsageCard } from '../components/RecentUsageCard'

/** Профиль: шапка, кредиты, последние расходы, язык и страна. Только то, что
 *  отдаёт текущий API. */
export const AccountSettings = () => (
  <section className="space-y-6">
    <ProfileHeader />
    {/* Две в ряд, только когда каждой хватает 320px — уже подписи ломались на 2–3 строки. */}
    <div className="grid gap-4 [grid-template-columns:repeat(auto-fit,minmax(min(100%,320px),1fr))]">
      <CreditsCard />
      <RecentUsageCard />
    </div>
    <LanguageCard />
    <CountryCard />
  </section>
)
